import { gql } from '@apollo/client'
import eventFragment from '~/graphql/fragments/event'

export const GET_EVENT_DATA = gql`
  query getEventData($id: ID!) {
    node(id: $id) {
      ... on Event {
        ...event
      }
    }
  }

  ${eventFragment}
`
